// Centralized keys for localStorage and other constants

export const GSHEET_ID = "1RGpV2hfwMVVzq1IsZoClnLjMscZ1fpmHb3ktEv1rrmE";
export const SHEET_NAME = "License_v3";
export const SHEET_URL = `https://docs.google.com/spreadsheets/d/${GSHEET_ID}/gviz/tq?tqx=out:json&sheet=${SHEET_NAME}`;
export const CHANGE_STATUS = `https://script.google.com/macros/s/AKfycbwqmCJmgiSqlluD3m9JT6q4ormAQUloK6i8WzRvFOYA2zhXPMAUzwtQy3Dl_7zeBlTSjQ/exec`;
// export const CHANGE_STATUS = `https://script.google.com/macros/s/AKfycbwiwfnG6iKaWUIoL60F8Qcdx5VvYKpqPUhoKiOJX8n2MkAqFzsEMpMs24xKUY2BuNAaFA/exec`;

export const LOCAL_STORAGE_KEYS = {
  LOGGED_IN_USER: "loggedInUser",
};
export function formatDateWithTime(value) {
  if (!value) return "";
  const dateMatch = typeof value === "string" && value.match(/^Date\((\d{4}),(\d{1,2}),(\d{1,2}),(\d{1,2}),(\d{1,2}),(\d{1,2})\)$/);
  let jsDate;
  if (dateMatch) {
    const year = parseInt(dateMatch[1], 10);
    const month = parseInt(dateMatch[2], 10) - 1;
    const day = parseInt(dateMatch[3], 10);
    const hour = parseInt(dateMatch[4], 10);
    const minute = parseInt(dateMatch[5], 10);
    const second = parseInt(dateMatch[6], 10);
    jsDate = new Date(year, month, day, hour, minute, second);
  } else if (typeof value === "number") {
    jsDate = new Date((value - 25569) * 86400 * 1000);
  } else {
    jsDate = new Date(value);
  }
  if (!jsDate || isNaN(jsDate.getTime())) return value;

  // Format as dd-mm-yyyy HH:MM:SS
  const pad = n => n.toString().padStart(2, "0");
  return `${pad(jsDate.getDate())}-${pad(jsDate.getMonth() + 1)}-${jsDate.getFullYear()} ${pad(jsDate.getHours())}:${pad(jsDate.getMinutes())}:${pad(jsDate.getSeconds())}`;
}

export function formatDate(value) {
  if (!value) return "";
  const dateMatch = typeof value === "string" && value.match(/^Date\((\d{4}),(\d{1,2}),(\d{1,2})\)$/);
  let jsDate;
  if (dateMatch) {
    const year = parseInt(dateMatch[1], 10);
    const month = parseInt(dateMatch[2], 10) - 1;
    const day = parseInt(dateMatch[3], 10);
    jsDate = new Date(year, month, day);
  } else if (typeof value === "number") {
    jsDate = new Date((value - 25569) * 86400 * 1000);
  } else {
    jsDate = new Date(value);
  }
  if (!jsDate || isNaN(jsDate.getTime())) return value;

  // Format as dd-mm-yyyy
  const pad = n => n.toString().padStart(2, "0");
  return `${pad(jsDate.getDate())}-${pad(jsDate.getMonth() + 1)}-${jsDate.getFullYear()}`;
}